export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/add.0a048278.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};